

/**
 * Genera un slug SEO-friendly a partir de un texto
 * @param {string} text - Texto a convertir en slug
 * @returns {string} - Slug generado
 */
export const generateSlug = (text) => {
  if (!text) return '';
  
  return text
    .toString()
    .toLowerCase()
    .trim()
    // Reemplazar caracteres especiales del español
    .replace(/[áàäâ]/g, 'a')
    .replace(/[éèëê]/g, 'e')
    .replace(/[íìïî]/g, 'i')
    .replace(/[óòöô]/g, 'o')
    .replace(/[úùüû]/g, 'u')
    .replace(/ñ/g, 'n')
    .replace(/ç/g, 'c')
    // Reemplazar espacios y caracteres especiales con guiones
    .replace(/[^a-z0-9 -]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    // Remover guiones al inicio y final
    .replace(/^-+/, '')
    .replace(/-+$/, '');
};

/**
 * Genera una URL completa para un evento
 * @param {object} event - Objeto del evento
 * @returns {string} - URL del evento
 */
export const generateEventUrl = (event) => {
  if (!event || !event.id) return '/events';
  
  const slug = generateSlug(event.name || '');
  return `/events/${event.id}${slug ? `/${slug}` : ''}`;
};

export const dataActivities = [
    // {
    //     country: 'PANAMÁ',
    //     site: 'Av Omar Torrijos Herrera, Summit, Provincia de Panamá, Panamá',
    //     date: '15 DE JUNIO 2024',
    //     hour: '7AM a 4PM',
    //     activities: [
    //      'Ingreso y entrega de tu kit de hidratación',
    //      'Hike en las instalaciones del Parque Summit: El sendero del Summit cuenta con una distancia de 2.7Km, es un circuito circular de 75 mts de desnivel positivo, el recorrido tiene una duración aproximada de 1h a 1h30m. Durante el trayecto se puede apreciar la diversidad de flora y fauna como el cantar de las aves.', 
    //      'Talleres y conversatorios de temas relacionados a senderismo y productos como: talleres de montaña, outdoor wellness, yoga, equipo ideal para hike y accesorios.', 
    //      'Música con DJ'],
    //     activity: 'Música en vivo con',
    //     title: 'Los Dollies',
    //     image: '/images/music-1.jpg'
    // },
    // {
    //     country: 'Guatemala',
    //     site: '<span class="text-2xl mt-1">CARMONA TRAILS</span><br>Km 3.5 carretera a Santa María de Jesús, Antigua Guatemala, Sacatepéquez',
    //     date: 'Sábado 27 de julio 2024',
    //     hour: '7:00 AM a 2:00 PM ',
    //     activities: [
    //         'Caminata por los senderos de Carmona Trails, con una distancia de 6 a 8 kilómetros y una altura aproximada 1,980 msnm',
    //         ' Ingreso y entrega de tu kit de recuperación',
    //         'Workshop relacionados a senderismo y productos de montaña',
    //          'Música con DJ',
    //          'Comida y bebida',
    //         ],
    //     activity: 'Música en vivo con',
    //     title: 'Viento en Contra',
    //     image: '/images/VIENTO-EN-CONTRA.png',
    //     soldOut: true,

    // },

     {
       country: 'Costa Rica',
       site: 'Hacienda La Central, Provincia de Cartago, Turrialba, Costa Rica',
     date: '29 DE JUNIO 2024',
         hour: '7:00 AM a 4:00 PM',
         activities: [
             'Ingreso y entrega de kit de recuperación ', 
             'Hike en las instalaciones de Hacienda la Central: Caminata al pie del Volcán Turrialba, durante el recorrido se apreciará el verde de la naturaleza acompañado del Bosque Quemado del Silencio , cañones, ríos de minerales, coladas de lava, los cuales son paisajes únicos.', 
             'Comida y bebidas',
              'Talleres y conversatorios de temas relacionados a senderismo y productos como: talleres de montaña, outdoor wellness, yoga, equipo ideal para hike y accesorios.',
              'Música de DJ'
             ],
         activity: 'Música en vivo con',
     title: 'Flashback',
     image: '/images/Flashback.png',
         soldOut: true,
    },

    {
        country: 'Panamá',
        site: 'Parque Summit, Av Omar Torrijos Herrera, Summit, Provincia de Panamá, Panamá',
        date: '06 DE JULIO 2024',
        hour: '7:00 AM a 4:00 PM',
        activities: [
            'Ingreso y entrega de kit de recuperación ', 
            'Hike en las instalaciones Parque Summit: Un sendero con una distancia de 2.7 KM, un circuito circular con 75 mt de desnivel positivo y con una duración de 1h 30, en este lugar disfrutaremos de todas sus áreas verdes.',
            'Comida y bebidas',
             'Talleres y conversatorios de temas relacionados a senderismo y productos como: talleres de montaña, equipo ideal para hike y accesorios.',
             'Música de DJ'
            ],
        activity: 'Música en vivo con',
        title: 'Los Dollies',
        image: '/images/los-dollies.jpg',
        soldOut: true,
    },
   
]